import type { WidgetVariant } from "@/types";

// Short per-target code; every event/storage/container name below derives
// from it, so the three bundles on one page never answer each other's events.
const CODE: Record<WidgetVariant, string> = {
  "on-site": "osw",
  "in-game": "igw",
  overlay: "overlay",
};

function prefix(variant: WidgetVariant): string {
  return `unibo-${CODE[variant]}`;
}

export function getWidgetOpenEvent(variant: WidgetVariant): string {
  return `${prefix(variant)}-open`;
}

export function getWidgetCloseEvent(variant: WidgetVariant): string {
  return `${prefix(variant)}-close`;
}

export function getWidgetStateChangeEvent(variant: WidgetVariant): string {
  return `${prefix(variant)}-state-change`;
}

export function getStorageKey(variant: WidgetVariant): string {
  return `widget-open-${CODE[variant]}`;
}

export function getDefaultContainerId(variant: WidgetVariant): string {
  return `unibo-widget-root-${CODE[variant]}`;
}
